import { Box, ContentBlock, Stack } from 'braid-design-system';
import { type ReactNode, useEffect } from 'react';

import AppBanner from 'src/components/atoms/AppBanner/AppBanner';
import MobileAppBanner from 'src/components/atoms/AppBanner/MobileAppBanner';
import ThreadSkeleton from 'src/components/atoms/Skeleton/ThreadSkeleton';
import { MobileSidebar } from 'src/components/molecules/Shared/Sidebar/MobileSidebar';
import { Sidebar } from 'src/components/molecules/Shared/Sidebar/Sidebar';
import { Layout } from 'src/components/templates/Layouts/Layout';
import { usePage } from 'src/provider/page';

import * as styles from './CommunityLayout.css';

interface Props {
  children: ReactNode;
}

const useUpdatePageStatus = () => {
  const { pageDispatch } = usePage();

  useEffect(() => {
    pageDispatch({ type: 'COMPLETE_LOADING' });
  }, [pageDispatch]);
};

export const CommunityLayout = ({ children }: Props) => {
  const {
    pageState: { isLoading },
  } = usePage();

  useUpdatePageStatus();

  return (
    <Layout>
      <ContentBlock width="large">
        <Box
          id="child-community-layout"
          padding={{
            mobile: 'small',
            tablet: 'small',
            desktop: 'xlarge',
            wide: 'xlarge',
          }}
          paddingRight={{
            mobile: 'none',
          }}
          paddingLeft={{
            mobile: 'none',
            tablet: 'small',
            desktop: 'xlarge',
            wide: 'xlarge',
          }}
          paddingBottom={{
            mobile: 'small',
            tablet: 'small',
            desktop: 'large',
            wide: 'large',
          }}
        >
          <Stack
            space={{
              mobile: 'large',
              tablet: 'large',
              desktop: 'xlarge',
              wide: 'xlarge',
            }}
          >
            <Box
              display="flex"
              flexDirection={{ mobile: 'column', tablet: 'row' }}
              gap={{
                mobile: 'small',
                tablet: 'medium',
                desktop: 'large',
                wide: 'large',
              }}
            >
              <Box
                display={{
                  mobile: 'none',
                  tablet: 'block',
                  desktop: 'block',
                  wide: 'block',
                }}
              >
                <Sidebar />
              </Box>
              <Box
                paddingTop="small"
                paddingBottom="none"
                display={{
                  mobile: 'block',
                  tablet: 'none',
                  desktop: 'none',
                  wide: 'none',
                }}
              >
                <MobileSidebar />
              </Box>
              <Box className={styles.ContentBlock}>
                {isLoading ? <ThreadSkeleton itemsToDisplay={10} /> : children}
              </Box>
            </Box>
            <AppBanner />
            <MobileAppBanner />
          </Stack>
        </Box>
      </ContentBlock>
    </Layout>
  );
};
